import React from 'react';

import { formatPrice } from '@/utils/formatPrice';
import { PercentageChangeBlock } from '@/components/elements/PercentageChangeBlock';
import styles from './PriceInfoWithChart.module.scss';

interface PriceInfoBlockProps {
  price?: number;
  priceChange?: number;
  override?: { price?: number; priceChange?: number; date?: Date };
}

const PriceInfoBlock: React.FC<PriceInfoBlockProps> = ({ price, priceChange, override }) => {
  // const now = new Date();
  // const dateObj = override?.date || now;
  // const dateStr = `${dateObj.getDate()}. ${dateObj.toLocaleString('en-US', { month: 'short' })}, ${dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}`;
  const showPrice = override?.price !== undefined ? override.price : price;
  const showChange = override?.priceChange !== undefined ? override.priceChange : priceChange;
  
  // Check if price information is available
  const hasPriceInfo = showPrice !== undefined && showPrice > 0;
  
  return (
    <div className={styles.priceInfoBlockWrapper}>
      <div className={styles.priceInfoBlockLeft}>
        {hasPriceInfo ? (
          <>
            <span className={styles.priceInfoBlockPrice}>${formatPrice(showPrice)}</span>
            {showChange !== undefined && (
              <PercentageChangeBlock value={showChange} fontSize={12} className={styles.priceInfoBlockChange} />
            )}
          </>
        ) : (
          <span className={styles.priceInfoBlockNoPrice}>No price information available at this time.</span>
        )}
      </div>
    </div>
  );
};

export default PriceInfoBlock;
